<template>
  <section class="header-container">
    <section
      id="header-background"
      class="home header-background"
      :class="{
        clipped: showRijnjaContent,
        full: !showRijnjaContent
      }"
      :style="[homeBackground, clipPath]"
    ></section>
    <transition name="background-fade">
      <section
        v-if="backgroundFade"
        class="header-background order"
        :style="{
          backgroundImage: newBg,
          backgroundPositionX: this.rootStore.interaction.backgroundPosX,
          backgroundPositionY: this.rootStore.interaction.backgroundPosY
        }"
      ></section>
    </transition>
    <div class="content" :class="{ portal: !showRijnjaContent }">
      <slot></slot>
    </div>

    <button
      @click="scrollDown"
      class="scroll-down"
      :class="{ hide: scrollPosition > 75 }"
      v-if="showRijnjaContent"
      aria-label="Scroll down"
    >
      <img src="@/images/chevron-down.svg" alt="scroll-button" />
    </button>
    <rijnja-regelt-het
      @click.native="$router.push({ name: 'contact' })"
      :color="rootStore.theme.badgeColor"
      :class="{
        'footer-ad': rootStore.theme.customFields.printStoreAd.showFooter
      }"
      class="rrh"
      v-if="rootStore.theme.showBadge && $route.name === 'home'"
    ></rijnja-regelt-het>
  </section>
</template>

<script>
import ResizeObserver from 'resize-observer-polyfill'
import RijnjaRegeltHet from '@/components/RijnjaRegeltHet.vue'

export default {
  data() {
    return {
      resizeObserver: undefined,
      clipPath: {},
      scrollPosition: 0
    }
  },
  components: {
    RijnjaRegeltHet
  },
  mounted() {
    this.RijnjaRegeltHetresizeObserver = new ResizeObserver(
      this.onResize
    ).observe(document.body)
    this.onResize()

    window.addEventListener('scroll', this.updateScroll)
  },
  computed: {
    newBg() {
      const bg =
        "url('" +
        window.location.protocol +
        '//images.rijnja.nl/images/backgrounds/' +
        this.rootStore.interaction.backgroundImage +
        "')"
      return bg
    },
    homeBackground() {
      let bg = {}
      if (this.rootStore.theme.backgroundImage) {
        bg.backgroundImage =
          "url('" +
          window.location.protocol +
          '//images.rijnja.nl/images/backgrounds/' +
          this.rootStore.theme.backgroundImage +
          "')"
        ;(bg.backgroundPositionX = this.rootStore.theme.backgroundPosX),
          (bg.backgroundPositionY = this.rootStore.theme.backgroundPosY)
      }

      return bg
    },
    showRijnjaContent() {
      if (
        this.$route.name === 'home' &&
        this.rootStore.theme.showRijnjaContent
      ) {
        return true
      } else {
        return false
      }
    },
    backgroundFade() {
      if (this.rootStore.interaction.backgroundImage && !this.fullBackground) {
        return true
      } else {
        return false
      }
    },
    fullBackground() {
      return this.rootStore.currentSection === 'printstore'
    }
  },
  methods: {
    updateScroll() {
      this.scrollPosition = window.scrollY
    },
    onResize() {
      if (window.innerWidth > 767 && this.showRijnjaContent) {
        const introText = document.getElementById('intro-text')
        let introPos
        if (introText) {
          introPos = introText.getBoundingClientRect().x
        }

        let headerHeight = document.getElementById('header-background')
          .offsetHeight

        let straal = headerHeight - 100
        let xPos = introPos - 80 - straal

        this.clipPath = {
          clipPath: 'circle(' + straal + 'px at ' + xPos + 'px 100px)'
        }
      } else if (this.fullBackground && window.innerWidth >= 940) {
        let theLeftMargin = document
          .getElementById('home-wrapper')
          .getBoundingClientRect().x

        let xPos = theLeftMargin - 757

        this.clipPath = {
          clipPath: 'circle(1065px at ' + xPos + 'px 287px)'
        }
      } else if (this.fullBackground && window.innerWidth < 940) {
        this.clipPath = {
          backgroundImage: 'none'
        }
      } else {
        this.clipPath = {}
      }
    },
    scrollDown() {
      const element = document.getElementById('homepage')
      element.scrollIntoView({ behavior: 'smooth' })
    }
  },
  watch: {
    rootStore_backgrounds(val) {
      // preload all background images in browsercache
      val.forEach((bg) => {
        const img = new Image()
        img.src =
          window.location.protocol +
          '//images.rijnja.nl/images/backgrounds/' +
          bg
      })
    },
    'rootStore.currentSection': function (val) {
      this.onResize()
    }
  }
}
</script>

<style lang="scss" scoped>
.content {
  position: relative;
  left: 0;
  right: 0;

  &.portal {
    height: 100vh;
  }
}
.header-container {
  width: 100vw;
  position: relative;
  top: 0;
  left: 0;
}

.header-background {
  background-repeat: no-repeat;
  background-size: cover;
  width: 100%;
  height: 100%;
  position: absolute;
  min-height: 590px;

  &.full {
    position: fixed;
  }

  &.order {
    position: fixed;
  }
}

.background-fade-enter-active,
.background-fade-leave-active {
  transition: opacity 0.75s;
}
.background-fade-enter-from,
.background-fade-leave-to {
  opacity: 0;
}

.clipped {
  transition: clip-path 0.2s;
  clip-path: circle(740px at 50% -225px);
  height: 100%;
}

.scroll-down {
  width: 46px;
  height: 46px;
  border-radius: 50%;
  position: absolute;
  background: white;
  box-shadow: rgba(0, 0, 0, 0.33) 0 0px 32px -4px;
  //  top: calc(100vh - 81px);
  top: min(calc(100vh - 81px), 890px);
  left: calc(50% - 23px);
  display: none;
  transition: opacity 0.2s;
  z-index: 10;

  &.hide {
    opacity: 0;
  }
}

.rrh {
  position: absolute;
  bottom: 20px;
  right: 20px;
  cursor: pointer;

  &.footer-ad {
    display: none;
  }
}

.rrh :deep(svg) {
  width: 91px;
}

@media only screen and (min-width: 375px) {
  .clipped {
    clip-path: circle(740px at 50% -150px);
  }

  .rrh :deep(svg) {
    width: 109px;
  }
}

@media only screen and (min-width: 480px) {
  .rrh {
    bottom: 32px;
    right: 32px;
  }
}

@media only screen and (min-width: 620px) {
  .clipped {
    clip-path: circle(740px at 50% -120px);
  }
}

@media only screen and (min-width: 768px) {
  .header-background {
    background-attachment: fixed;
  }

  @supports (-webkit-touch-callout: none) {
    //ios ipados hack
    .header-background {
      background-attachment: initial;
    }
  }
  .clipped {
    clip-path: circle(518px at calc(100vw - 850px) 235px);
  }

  .content {
    height: 100vh;
    min-height: 580px;
    max-height: 1000px;

    &.portal {
      height: 100vh;
      max-height: none;
    }
  }

  .scroll-down {
    display: block;
  }
}

@media only screen and (min-width: 1024px) {
  .rrh :deep(svg) {
    width: 121px;
  }
}

@media only screen and (min-width: 2350px) {
  .rrh.footer-ad {
    display: block;
  }
}
</style>
